import { bootstrapApplication } from '@angular/platform-browser';
import { App } from './app/app';
import { appRouting } from './app/app.routes';
import { provideHttpClient } from '@angular/common/http';

bootstrapApplication(App, {
  providers: [
    appRouting,               // ✅ already calls provideRouter inside app.routes.ts
    provideHttpClient()
  ]
});
